import React from "react";
import "./css/FormComponents.css";

/**
 * SubmitButton Component
 * A reusable button component for form submission with consistent styling and behavior
 *
 * @param {Object} props - Component props
 * @param {string} props.text - Button text
 * @param {string} props.loadingText - Text to display when isLoading is true
 * @param {boolean} props.isLoading - Whether the button is in loading state
 * @param {boolean} props.disabled - Whether the button is disabled
 * @param {string} props.className - Additional CSS classes to apply
 * @param {function} props.onClick - Click handler function
 * @param {string} props.type - Button type attribute
 * @param {React.ReactNode} props.icon - Icon to display in the button
 * @returns {React.ReactElement} SubmitButton component
 */
const SubmitButton = ({
  text,
  loadingText,
  isLoading = false,
  disabled = false,
  className = "",
  onClick,
  type = "submit",
  icon,
  ...rest
}) => {
  const buttonText = isLoading && loadingText ? loadingText : text;
  const isDisabled = disabled || isLoading;

  return (
    <button
      type={type}
      className={`submit-button ${isLoading ? "loading" : ""} ${
        isDisabled ? "disabled" : ""
      } ${className}`}
      disabled={isDisabled}
      onClick={onClick}
      {...rest}
    >
      {isLoading && <span className="loading-spinner"></span>}
      {icon && <span className="button-icon">{icon}</span>}
      <span className="button-text">{buttonText}</span>
    </button>
  );
};

export default SubmitButton;
